// ─── Score ring constants ─────────────────────────────────────────────────────

export const RADIUS = 52;
export const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

// ─── Color ────────────────────────────────────────────────────────────────────

export function getRingColor(pct: number): string {
  if (pct >= 0.8) return '#7F77DD';
  if (pct >= 0.5) return '#1D9E75';
  return '#E24B4A';
}

// ─── Headings ─────────────────────────────────────────────────────────────────

export function getResultHeading(pct: number): string {
  if (pct >= 0.9) return 'O for Outstanding!';
  if (pct >= 0.7) return 'E for Exceeds Expectations!';
  if (pct >= 0.5) return 'A for Acceptable';
  if (pct >= 0.3) return 'P for Poor';
  if (pct >= 0.1) return 'D for Dreadful';
  return 'T for Troll';
}

// ─── Earned titles ────────────────────────────────────────────────────────────
// TODO: Finalize original title names before launch (avoid IP-adjacent terms)

const EARNED_TITLES: Record<string, Record<string, string>> = {
  high: {
    'N.E.W.T.':  'Headmaster',
    'O.W.L.':    'Professor',
    'Very Hard': 'Prefect',
    'Hard':      'Nerd',
    default:     'Good Student',
  },
  mid: { default: 'Apprentice' },
  low: { default: 'Muggle' },
};

export function getEarnedTitle(score: number, total: number, modeName: string): string {
  const pct = total > 0 ? score / total : 0;
  const tier = pct >= 0.8 ? 'high' : pct >= 0.5 ? 'mid' : 'low';
  const map = EARNED_TITLES[tier];
  return map[modeName] ?? map.default;
}

// ─── Star positions (header decoration) ──────────────────────────────────────

export const STAR_POSITIONS = [
  { top: '15%', left: '4%',  size: 5 },
  { top: '60%', left: '7%',  size: 3 },
  { top: '80%', left: '2%',  size: 3 },
  { top: '25%', left: '12%', size: 3 },
  { top: '70%', left: '15%', size: 5 },
  { top: '10%', left: '88%', size: 5 },
  { top: '45%', left: '92%', size: 3 },
  { top: '75%', left: '96%', size: 3 },
  { top: '20%', left: '85%', size: 3 },
  { top: '65%', left: '82%', size: 5 },
  { top: '88%', left: '90%', size: 3 },
  { top: '50%', left: '5%',  size: 3 },
] as const;